import { axiosInstance } from "../axios";

const org_subscription_route = `${process.env.REACT_APP_ORG_BASE}/subscriptions`;
const org_plans_route = `${process.env.REACT_APP_ORG_BASE}/plans`;

// ========== PLANS API CALLS ==========

export const getProduct = (params) => {
  return axiosInstance.get(org_plans_route, { params });
};

/**
 * Get all plans with pagination and filters
 */
export const getAllPlans = (params) => {
  return axiosInstance.get(org_plans_route, { params });
};

/**
 * Get public plans
 */
export const getPublicPlans = (params) => {
  return axiosInstance.get(`${org_plans_route}/public`, { params });
};

/**
 * Get plan by ID
 */
export const getPlanById = (planId) => {
  return axiosInstance.get(`${org_plans_route}/${planId}`);
};

/**
 * Get plan by slug
 */
export const getPlanBySlug = (slug) => {
  return axiosInstance.get(`${org_plans_route}/slug/${slug}`);
};

/**
 * Get plan features
 */
export const getPlanFeatures = (planId) => {
  return axiosInstance.get(`${org_plans_route}/${planId}/features`);
};

/**
 * Create new plan
 */
export const createPlan = (payload) => {
  return axiosInstance.post(org_plans_route, payload);
};

/**
 * Update plan
 */
export const updatePlan = (planId, payload) => {
  return axiosInstance.patch(`${org_plans_route}/${planId}`, payload);
};

/**
 * Delete plan
 */
export const deletePlan = (planId) => {
  return axiosInstance.delete(`${org_plans_route}/${planId}`);
};

/**
 * Set plan features
 */
export const setPlanFeatures = (planId, payload) => {
  return axiosInstance.post(`${org_plans_route}/${planId}/features`, payload);
};

// ========== SUBSCRIPTIONS API CALLS ==========

/**
 * Get all subscriptions with pagination and filters (admin)
 */
export const getAllSubscriptions = (params) => {
  return axiosInstance.get(org_subscription_route, { params });
};

/**
 * Get subscription by ID
 */
export const getSubscriptionById = (subscriptionId) => {
  return axiosInstance.get(`${org_subscription_route}/${subscriptionId}`);
};

/**
 * Get customer subscriptions
 */
export const getCustomerSubscriptions = (customerId, params) => {
  return axiosInstance.get(`${org_subscription_route}/customer/${customerId}`, {
    params,
  });
};

/**
 * Create subscription
 */
export const createSubscription = (payload) => {
  return axiosInstance.post(org_subscription_route, payload);
};

/**
 * Upgrade plan
 */
export const upgradePlan = (subscriptionId, payload) => {
  return axiosInstance.patch(
    `${org_subscription_route}/${subscriptionId}/upgrade`,
    payload,
  );
};

/**
 * Downgrade plan
 */
export const downgradePlan = (subscriptionId, payload) => {
  return axiosInstance.patch(
    `${org_subscription_route}/${subscriptionId}/downgrade`,
    payload,
  );
};

/**
 * Change plan
 */
export const changePlan = (subscriptionId, payload) => {
  return axiosInstance.patch(
    `${org_subscription_route}/${subscriptionId}/change-plan`,
    payload,
  );
};

/**
 * Cancel subscription
 */
export const cancelSubscription = (subscriptionId, payload) => {
  return axiosInstance.patch(
    `${org_subscription_route}/${subscriptionId}/cancel`,
    payload,
  );
};

/**
 * Renew subscription
 */
export const renewSubscription = (subscriptionId, payload) => {
  return axiosInstance.patch(
    `${org_subscription_route}/${subscriptionId}/renew`,
    payload,
  );
};

/**
 * Get subscription history
 */
export const getSubscriptionHistory = (subscriptionId, params) => {
  return axiosInstance.get(
    `${org_subscription_route}/${subscriptionId}/history`,
    { params },
  );
};

/**
 * Check feature access
 */
export const checkFeatureAccess = (subscriptionId, params) => {
  return axiosInstance.get(
    `${org_subscription_route}/${subscriptionId}/feature-access`,
    { params },
  );
};
